import { GenericProperties } from '../../FlowDesigner/ActionPanel/GenericProperties';
import { VariableScope } from '../../FlowDesigner/Models/VariableScopes/VariableScope';
import useUserInterfaceMetadata from '../Hooks/useUserInterfaceMetadata';
import { ComponentTypes } from '../Models/ComponentTypes';
import { ParameterTypes } from '@@common';
import { ViewModel } from '../Models/ViewModel';
import { filterTreeManagedParameters } from '../Utils/ComponentTreeUtils';
import DialogInput from './Inputs/DialogInput';
import LayoutInput from './Inputs/LayoutInput';
import MenuInput from './Inputs/MenuInput';

type ViewPropertiesProps = {
	view: ViewModel;
	onViewChanged: (view: ViewModel) => void;
	variableScope?: VariableScope;
};

export function ViewProperties({ view, onViewChanged, variableScope }: ViewPropertiesProps) {
	const { componentByName } = useUserInterfaceMetadata();
	const parameters = filterTreeManagedParameters(componentByName.get(ComponentTypes.View)?.parameters ?? []);

	return (
		<GenericProperties<ViewModel> parameters={parameters} model={view} id={view.Id} onModelChanged={onViewChanged} variableScope={variableScope}>
			{(parameterMetadata, value, onValueChange) => {
				if (parameterMetadata.typeCustom === ParameterTypes.ViewMenu) {
					return <MenuInput menu={value} onMenuChange={onValueChange} />;
				}
				if (parameterMetadata.typeCustom === ParameterTypes.ViewDialog) {
					return <DialogInput dialog={value} onDialogChange={onValueChange} />;
				}
				if (parameterMetadata.typeCustom === ParameterTypes.Layout) {
					return <LayoutInput layout={value} onLayoutChange={onValueChange} />;
				}
				return null; // Fall back to default PropertyValueInput handling
			}}
		</GenericProperties>
	);
}
